import { createSlice } from '@reduxjs/toolkit';
import { Nullable, UserQuizDate } from '../../types';
import { Paginated } from '../../services/api-handlers/pagination';
import { takeOne } from '../../helpers/store';
import { listUserQuizzes } from '../thunks/user-quiz-thunks';
import { ReducerState } from '../configure-store';

export interface UserQuizState extends ReducerState {
    data: Paginated<UserQuizDate>;
    current: Nullable<UserQuizDate>;
}

const initialState: UserQuizState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'user-quiz',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(listUserQuizzes.pending, takeOne.pendingActionCase)
            .addCase(listUserQuizzes.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })
            .addCase(listUserQuizzes.rejected, takeOne.rejectedActionCase);
    },
});

export const {} = slice.actions;

export default slice.reducer;
